import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-text-skeleton',
  templateUrl: './text-skeleton.component.html',
})
export class TextSkeletonComponent {
  @Input() text: string | number | null | undefined;
  @Input() loading: boolean = false;
  @Input() width: string = '100%';

  get hasValue(): boolean {
    return this.text !== null && this.text !== undefined && this.text !== '';
  }
}
